import React from "react";
import BlogOverview from "../components/BlogOverview/BlogOverview";
import { fetchSubjectData } from "../api";
import { useInfiniteQuery } from "react-query";
import LoadingButton from "../components/LoadingButton/LoadingButton";

function Knowledge({ category, title }) {
  const limit = 6;

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useInfiniteQuery(
      ["school", category],
      async ({ pageParam = 0 }) => {
        return fetchSubjectData("school", category, pageParam, limit);
      },
      {
        getNextPageParam: (lastPage, allPages) => {
          // Wenn weniger Elemente zurückkommen als `limit`, ist Schluss
          if (lastPage.length < limit) return undefined;
          return allPages.length; // nächste pageNumber
        },
      }
    );

  // Alle geladenen Artikel zusammenführen
  const allItems = data?.pages.flat() || [];

  return (
    <>
      <h1 className="text-light text-center">{title}</h1>

      <BlogOverview
        data={allItems}
        category={`knowledge/${category}`}
        title={title}
      />

      {hasNextPage && (
        <div className="text-center mt-6">
          <LoadingButton
            onClick={() => fetchNextPage()}
            loading={isFetchingNextPage}
          />
        </div>
      )}
    </>
  );
}

export default Knowledge;
